










import { Vue, Component } from 'vue-property-decorator';
import Proveedores from '@/pantallas/Proveedor/Proveedores.vue';

@Component({
  components: { Proveedores },
})
export default class ProveedoresPantalla extends Vue {}
